import { render, staticRenderFns } from "./NewsletterTemplate.vue?vue&type=template&id=55cae97d&scoped=true"
import script from "./NewsletterTemplate.vue?vue&type=script&lang=js"
export * from "./NewsletterTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewsletterTemplate.vue?vue&type=style&index=0&id=55cae97d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cae97d",
  null
  
)

export default component.exports